<template>
  <header-middle />
  <bread-crumb :vector="vector"/>
  <banner-temp />
  <store-list :catId="catId" />
  <grid-template />
  <footer-template />
</template>

<script setup>
import HeaderMiddle from '../section/header/header.vue';
import GridTemplate from "../section/footer/grids.vue";
import FooterTemplate from "../section/footer/footer.vue";
import BreadCrumb from "../section/item/BreadCrumb.vue";
import StoreList from "../section/pages/Shops/items.vue"
import BannerTemp from "../section/item/BannerTemp.vue";
import { ref,computed,watch } from 'vue'
import { useRoute } from 'vue-router';
let route = useRoute();
let vector = ref()
let catId = ref(1)
let newPage = computed(() => route.params)
watch(newPage,() => {
  catId.value = route.params.item;
  getBreadCrumb()
}, { immediate: true })
async function getBreadCrumb(){
  let response = await fetch('https://radap.ir/Backend/api/section/pages/shops/breadCrumb.php?categoryId='+catId.value)
  let data = await response.json()
  vector.value = [
    {
      fa : data.name,
      path : '/Shops/'+data.id
    }
  ]
}
</script>
<style>
</style>